import {css, html, LitElement} from "lit";

const barAnimationMs = 200;

export class TopProgressBar extends LitElement {

    static styles = css`
        .top-progress-bar {
            width: 100%;
            height: 4px;
            z-index: 9999;
            top: 0
        }

        .bar {
            width: 0;
            height: 100%;
            transition: height .3s ease-in-out;
            background: #884efd
        }
        .bar {
            transition: width ${barAnimationMs}ms ease-in-out;
        }
    `

    static properties = {
        width: { type: Number, reflect: true },
        percent: { type: Number, reflect: true },
        _on: { type: Boolean},
    }

    constructor() {
        super();
    }

    render() {
        return html`<div class="top-progress-bar"><div class="bar"></div></div>`
    }

    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (!_changedProperties.has('percent')) {
            return;
        }

        let bar = this.renderRoot.querySelector('.bar');

        let previous = _changedProperties.get('percent');
        let current = this.percent;

        if (current === 100) {
            if (previous === 0 || previous === undefined || previous === null) {
                bar.style.width = '0';
                bar.style.height = '0';
                return;
            }
            bar.style.width = '100%';
            setTimeout(() => {
                bar.style.height = '0';
                bar.style.width = '0';
            },barAnimationMs+100);
            return;
        }

        let shouldBeVisible = (current > 0 && current < 100);


        bar.style.width = `${current}%`;
        bar.style.height = shouldBeVisible ? '100%' : '0';

    }

}

customElements.define('x-top-progress-bar', TopProgressBar);